import styled from "styled-components";

export const CardContainer = styled.div`
  padding: ${({ isSingleColumn }) => (isSingleColumn ? "24px" : "16px")};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  display: flex;
  flex-direction: ${({ isSingleColumn }) =>
    isSingleColumn ? "row" : "column"};
  justify-content: ${({ isSingleColumn }) =>
    isSingleColumn ? "normal" : "space-between"};
  align-items: ${({ isSingleColumn }) =>
    isSingleColumn ? "center" : "normal"};
  gap: 40px;
  height: 100%;
  box-sizing: border-box;
  box-shadow: 0px 0.628px 3.138px 0px rgba(63, 65, 66, 0.2);
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  order: ${({ isSingleColumn }) => (isSingleColumn ? 1 : 0)};
  flex: 1;
`;

export const CardHeading = styled.h1`
  all: unset;
  color: inherit;
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
`;

export const CardParagraph = styled.p`
  all: unset;
  color: inherit;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  flex: 1;
  opacity: 0.8;
`;

export const CardStep = styled.div`
  color: inherit;
  font-size: ${({ isSingleColumn }) => (isSingleColumn ? "120px" : "40px")};
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
`;
